import { clearAuthTokens } from '@/lib/tokenStorage';

/**
 * Matches the GraphQL baseApi behavior: an expired/invalid token on a REST
 * call sends the user back through login instead of surfacing "status: 401".
 */
export function redirectToLoginIfUnauthorized(response: Response): void {
  if (response.status !== 401) return;
  clearAuthTokens();
  window.location.href = '/login';
}
